import styled, { css } from 'styled-components';
import type { ColorVariant } from './BrandByMonarx.types';

type StylesProps = {
  $variant: ColorVariant;
};

export const Row = styled.div<StylesProps>`
  ${({ $variant }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 100%;
    ${$variant === 'gradient' && css`
      flex-wrap: wrap;
    `}
  `}
`;

export const ShieldWrap = styled.div<{ $isMobile: boolean }>`
  ${({ $isMobile }) => css`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 40px;

    ${!$isMobile && css`
      width: 59px;
      height: 65px;
    `}

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  `}
`;

export const BrandTextCol = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  `}
`;

export const ProductTitle = styled.span<{ $isMobile: boolean; $variant: ColorVariant }>`
  ${({ theme, $isMobile, $variant }) => css`
    font-weight: ${theme.v3.font.weights.medium};
    font-size: 22px;

    ${!$isMobile && css`
      font-size: ${theme.v3.font.sizes['2xlarge']};
 
    `}

    ${$variant === 'light' && css`
      color: ${theme.v3.colors.brand.snappyBlue[10]};
    `}

    ${$variant === 'gradient' && css`
      color: ${theme.v3.colors.neutral[100]};
      line-height: ${theme.v3.font.lineHeight.relaxed};
      white-space: nowrap;
    `}
  `}
`;

export const ProductSubtitle = styled.span<{ $isMobile: boolean; $variant: ColorVariant }>`
  ${({ theme, $isMobile, $variant }) => css`
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    padding-left: 2px;
    font-size: ${theme.v3.font.sizes.mini};

    ${!$isMobile && css`
      font-size: ${theme.v3.font.sizes.medium};
    `}

    ${$variant === 'light' && css`
      background: linear-gradient(
        171deg,
        ${theme.v3.colors.brand.snappyBlue[10]} 14.84%,
        ${theme.v3.colors.brand.snappyBlue[40]} 85.61%
      );
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
    `}

    ${$variant === 'gradient' && css`
      color: ${theme.v3.colors.neutral[100]};
      opacity: 0.92;
    `}
  `}
`;

export const ProBadge = styled.span<{ $darkBadge: boolean }>`
  ${({ theme, $darkBadge }) => css`
    background: ${$darkBadge ? theme.v3.colors.brand.snappyBlue[10] : theme.v3.colors.neutral[100]};
    border-radius: 1000px;
    color: ${$darkBadge ? theme.v3.colors.neutral[100] : theme.v3.colors.brand.snappyBlue[10]};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.bold};
    padding: ${theme.v3.spacing.nano};
    text-transform: uppercase;
    width: 46px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      margin-left: auto;
      margin-right: auto;
      width: fit-content;
    }
  `}
`;

export const TopRow = styled.div`
  ${() => css`
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
    justify-content: center;
  `}
`;
